import { Box } from '@mui/material'
import { styled } from '@mui/styles'
import React from 'react'
import TextContainer from '../Texts/TextContainer'
import { Row } from '../../global/styledComponents'

const FooterContainer = styled(Box)({
    width: "100%",
    padding: "1rem 2rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    minHeight: "10vh",
    height: "10vh",
    maxHeight: "10vh"
})
const linkStyle = {
    color: "#fff",
    fontFamily: "'Yekan !important'",
    textDecoration: "none"
}
function Footer() {

    return (
        <FooterContainer bgcolor="primary.main">
            <TextContainer
                color="secondary.main"
                fontSize="1rem"
                width="100%"
                justifyContent="right"
            >
                © کلیه حقوق سایت متعلق به yaadin.com می باشد
            </TextContainer>
            <Row gap=".5rem" width="100%" justifyContent="left">
                <a
                    style={linkStyle}
                    href='/'
                >
                    حریم خصوصی
                </a>
                |
                <a
                    style={linkStyle}
                    href='/'
                >
                    شرایط استفاده
                </a>
            </Row>
        </FooterContainer>
    )
}

export default Footer
